module.exports = __webpack_public_path__ + "img/08645359000128.35f85c75.png";